export const isRelativeUrl = url => {
  return !url.startsWith('http')
}
